// =============================================================================
// TWO COLUMN SECTION COMPONENT
// =============================================================================
// Renders two child components side by side in a 2-column layout

import React from 'react';
import type { ContentComponent } from '@/types';
import { ContentRenderer } from '@/components/ContentRenderer';
import './TwoColumnSection.scss';

interface TwoColumnSectionProps {
  component: ContentComponent;
}

/**
 * Two Column Section Component
 * Renders two components side by side
 */
export const TwoColumnSection: React.FC<TwoColumnSectionProps> = ({ component }) => {
  const { id, metadata } = component;
  
  // Get the two components to render
  const leftComponent = metadata?.leftComponent as ContentComponent | undefined;
  const rightComponent = metadata?.rightComponent as ContentComponent | undefined;
  
  if (!leftComponent || !rightComponent) {
    // Missing left or right component
    return null;
  }
  
  return (
    <section id={id} className="content-section two-column-section">
      <div className="container">
        <div className="two-column-grid">
          <div className="two-column-left">
            <ContentRenderer components={[leftComponent]} />
          </div>
          <div className="two-column-right">
            <ContentRenderer components={[rightComponent]} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TwoColumnSection;

